import { refreshOutputOrderSimStock } from '../forms/output-orders-sim-stock.js';

/**
 * Recarrega pré-reserva / saldo simulado das linhas ao mudar produto ou programa.
 */
export default function (..._args)
{
	return {
		async actions(_ev, _publisher, _value)
		{
			const node = document.querySelector(this.selector);
			const formRoot = node?.closest?.('#order') || document.querySelector('#order');
			if (!formRoot)
				return;
			try
			{
				await refreshOutputOrderSimStock(formRoot);
			}
			catch (_e)
			{
				/* noop */
			}
		},
	};
}
